import React from "react";

// PlantAdopting "P" symbol: map pin / teardrop containing a leaf, a warm sun,
// and carved agricultural field terraces.
export const LogoMark = ({ size = 40, className = "" }) => (
  <img
    src="/brand/icon.png"
    width={size}
    height={size}
    className={className}
    style={{ objectFit: "contain" }}
    alt=""
    aria-hidden="true"
  />
);

export const Logo = ({ light = false, compact = false }) => (
  <div className="flex items-center gap-2.5 select-none" data-testid="logo">
    <LogoMark size={compact ? 34 : 40} />
    <div className="leading-none">
      <span
        className={`font-serif font-bold tracking-tight ${compact ? "text-xl" : "text-2xl"} ${
          light ? "text-[#F8F5EA]" : "text-[#2A2521]"
        }`}
      >
        Plant<span className="text-[#C46A3A]">A</span>dopting
      </span>
      {!compact && (
        <span
          className={`block text-[9px] font-sans font-semibold uppercase tracking-[0.22em] mt-0.5 ${
            light ? "text-[#E2DACB]" : "text-[#8FA878]"
          }`}
        >
          Living Heritage Atlas
        </span>
      )}
    </div>
  </div>
);

